import * as React from "react";
import PropTypes from "prop-types";

const FeatureGrid = ({ gridItems }) => (
  <div className="columns is-multiline feature-grid">
    {gridItems.map((item) => (
      <div key={item.text} className="column is-6 feature-grid-column">
        <section className="section feature-grid-section">
          <div className="has-text-centered feature-grid-media">
            <div
              className="feature-image-wrap"
              style={{
                width: "240px",
                display: "inline-block",
              }}
            >
              <img
                src={item.image.publicURL}
                alt={item.alt || ""}
                className="feature-image"
              />
            </div>
          </div>
          <p className="feature-grid-text">{item.text}</p>
        </section>
      </div>
    ))}
  </div>
);

FeatureGrid.propTypes = {
  gridItems: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string,
      image: PropTypes.shape({
        publicURL: PropTypes.string.isRequired,
      }),
      text: PropTypes.string,
    })
  ),
};

export default FeatureGrid;
